// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-legend-toggle,.legend-orientation-toggle,.legend-opacity-slider,.legend-colorize-rows-toggle{margin-top:8px;margin-bottom:16px}.hover-legend-toggle label.legend-orientation-label,.legend-orientation-toggle label.legend-orientation-label,.legend-opacity-slider label.legend-orientation-label,.legend-colorize-rows-toggle label.legend-orientation-label{color:#9e9ead}.legend-orientation--horizontal{margin-bottom:8px !important}", ""]);
// Exports
module.exports = exports;
